import React from "react";
import "./circleloading.css"
import LoadingSpinner from "../loadingSpinner";

const CircleLoading = () => {
  return (
    <div style={{display:"flex",justifyContent:"center",width:"100%",height:"100vh",alignItems:"center"}}>
  
{/* <div class="loader">
  <div class="justify-content-center jimu-primary-loading"></div>
</div> */}
<LoadingSpinner />

    </div>
  );
};

export default CircleLoading;
